<sigv-input-data-table
  [columns]="pageData.displayColumns"
  [(value)]="supplementRecordsTableValue.controls"
  [dataKey]="'value.seqId'"
  [(first)]="pageData.first"
  [frozenColCount]="1"
  [scrollable]="true"
  [scrollHeight]="'500px'"
  [paginator]="false"
  [lazy]="true"
  [showInformation]="false"
  [reorderableColumns]="false"
  [editWithDialog]="true"
  [totalRecords]="pageData.pageInfo.totalRecords"
  [editCancelAlert]="true"
  preferenceKey="Retail_SupplementRecords_DataTable"
  class="review-table"
>
  <ng-template
    pTemplate="body"
    let-rowData
    let-rowIndex="rowIndex"
    let-editing="editing"
    let-columns="columns"
  >
    <ng-container *ngIf="true; else tableRow">
      <tr>
        <ng-container *ngTemplateOutlet="tableRow"></ng-container>
      </tr>
    </ng-container>
    <ng-template #tableRow>
      <ng-container *ngFor="let col of columns; let i = index">
        <td [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'reviewDocType'">
            <div
              style="word-break: break-all"
              [ngStyle]="{
                color: changedFields['reviewDocType_' + rowIndex]
                  ? '#bc9e5c'
                  : 'inherit'
              }"
            >
              {{
                rowData.controls.reviewDocType.getRawValue()
                  | optionsMapping : pageData.selectionList.reviewDocTypeOptions
                  | replaceNullWith : '-'
              }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'documentTypes'">
            <div
              style="word-break: break-all"
              [ngStyle]="{
                color: changedFields['addDocType_' + rowIndex]
                  ? '#bc9e5c'
                  : 'inherit'
              }"
            >
              {{
                rowData.controls.addDocType.getRawValue()
                  | optionsMapping : pageData.selectionList.documentTypeOptions
                  | replaceNullWith : '-'
              }}
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'msgSenderUserNo'">
            <div
              style="word-break: break-all"
              [ngStyle]="{
                color: changedFields['createUserNo_' + rowIndex]
                  ? '#bc9e5c'
                  : 'inherit'
              }"
            >
              {{
                rowData.controls.createUserNo.getRawValue()
                  | userComposer
                  | async
                  | replaceNullWith : '-'
              }}
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'supplementExplanation'">
            <div
              style="word-break: break-all"
              [ngStyle]="{
                color: changedFields['awaitingDescription_' + rowIndex]
                  ? '#bc9e5c'
                  : 'inherit'
              }"
            >
              {{ rowData.controls.awaitingDescription.getRawValue() }}
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'messageInformPerson'">
            <div
              style="word-break: break-all"
              [ngStyle]="{
                color: changedFields['msgRecpt_' + rowIndex]
                  ? '#bc9e5c'
                  : 'inherit'
              }"
            >
              <sigv-input-multi-select
                [bindingFormControl]="rowData.controls.msgRecpt"
                [selectOptions]="pageData.selectionList.msgRecptOptions"
                [isReadOnly]="true"
              ></sigv-input-multi-select>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'supplementCreateTime'">
            <div
              style="word-break: break-all"
              [ngStyle]="{
                color: changedFields['awaitingCreationTime_' + rowIndex]
                  ? '#bc9e5c'
                  : 'inherit'
              }"
            >
              {{
                rowData.controls.awaitingCreationTime.getRawValue()
                  | date : envConfig.format.datetime
                  | replaceNullWith : '-'
              }}
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'actualRestoreTime'">
            <div
              style="word-break: break-all"
              [ngStyle]="{
                color: changedFields['awaitingFinishTime_' + rowIndex]
                  ? '#bc9e5c'
                  : 'inherit'
              }"
            >
              {{
                rowData.controls.awaitingFinishTime.getRawValue()
                  | date : envConfig.format.datetime
                  | replaceNullWith : '-'
              }}
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'memo'">
            <div
              style="word-break: break-all"
              [ngStyle]="{
                color: changedFields['remarks_' + rowIndex]
                  ? '#bc9e5c'
                  : 'inherit'
              }"
            >
              {{ rowData.controls.remarks.getRawValue() }}
            </div>
          </ng-container>
        </td>
      </ng-container>
    </ng-template>
  </ng-template>
</sigv-input-data-table>
